// extracted by mini-css-extract-plugin
module.exports = {"outer":"PageStatus_outer__TYodB","animatedBackground":"PageStatus_animatedBackground__2q7v0","inner":"PageStatus_inner__2xhw7"};